import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error, TipoTecnico } from '@rpe/registro-personas-empresas-lib';

export const entityTiposTecnicoAdapter: EntityAdapter<TipoTecnico> =
  createEntityAdapter<TipoTecnico>({
    selectId: (model) => model.id,
    sortComparer: (a: TipoTecnico, b: TipoTecnico): number =>
      a.nombre.toString().localeCompare(b.nombre.toString())
  });

export interface EntityTiposTecnicoState extends EntityState<TipoTecnico> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityTiposTecnicoState =
  entityTiposTecnicoAdapter.getInitialState({
    isLoading: false,
    error: null
  });
